module.exports = __webpack_public_path__ + "static/16-employee-tag 1-83e65c926e5c5e0ed0d6db12b4acda37.svg";